import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function toneForValue(value) {
    if (value >= 80)
        return { bar: "bg-emerald-500", text: "text-emerald-700" };
    if (value >= 60)
        return { bar: "bg-amber-500", text: "text-amber-700" };
    return { bar: "bg-red-500", text: "text-red-700" };
}
/**
 * A confidence-score bar: a short horizontal track plus a color-ramped
 * percentage, so confidence reads as a magnitude at a glance instead of
 * requiring the reader to parse a bare number in a table column.
 */
export function ConfidenceBar({ value, className = "", showLabel = true }) {
    const clamped = Math.max(0, Math.min(100, value));
    const tone = toneForValue(clamped);
    return (_jsxs("div", { className: ["flex items-center gap-2", className].join(" "), children: [_jsx("div", { className: "h-1.5 w-16 flex-none overflow-hidden rounded-full bg-slate-100", role: "progressbar", "aria-valuenow": clamped, "aria-valuemin": 0, "aria-valuemax": 100, children: _jsx("div", { className: ["h-full rounded-full", tone.bar].join(" "), style: { width: `${clamped}%` } }) }), showLabel ? (_jsxs("span", { className: ["font-mono text-xs font-semibold tabular-nums", tone.text].join(" "), children: [clamped, "%"] })) : null] }));
}
